// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateId = () => {
  const estimate = useContext(EstimateContext);
  return estimate?.inputs?.id;
};
